import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ZendeskTicketContent } from 'src/app/interfaces/zendesk-ticket-content';

import { BaseModel } from './base-model';
import { Company } from './company';
import { Note } from './note';
import { Vendor } from './vendor';
import { ZendeskTicketComment } from './zendesk-ticket-comment';

export class ZendeskTicket extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ZendeskTicketProperties: (
    | {
        property: keyof ZendeskTicket;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ZendeskTicket;
        type: 'alias';
      }
    | {
        property: keyof ZendeskTicket;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ZendeskTicketId', type: 'column', dataType: 'number' },
    { property: 'NoteId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'ticketContentJSON', type: 'column', dataType: 'JSON' },
    { property: 'status', type: 'column', dataType: 'string' },
    { property: 'isDeleted', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'Company', model: 'Company', type: 'association' },
    { property: 'Note', model: 'Note', type: 'association' },
    {
      property: 'ZendeskTicketComments',
      model: 'ZendeskTicketComment',
      type: 'association'
    }
  ];

  static {
    ZendeskTicket.ZendeskTicketProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ZendeskTicket.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ZendeskTicket.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ZendeskTicket.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ZendeskTicketObject: Partial<ZendeskTicket>) {
    super();

    ZendeskTicket.ZendeskTicketProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ZendeskTicketObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ZendeskTicketId?: string;
  NoteId?: number;
  CompanyId?: number;
  VendorId?: number;
  ticketContentJSON?: ZendeskTicketContent;
  status?: 'New' | 'Open' | 'Pending' | 'On-Hold' | 'Solved' | 'Closed' | null;
  isDeleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  Vendor?: Vendor;
  Company?: Company;
  Note?: Note;
  ZendeskTicketComments?: ZendeskTicketComment[];
}

/*
ZendeskTicket.associate = (models) => {
  ZendeskTicket.belongsTo(models.Note, { targetKey: 'ticketId', foreignKey: 'ZendeskTicketId' });
};
*/
